module.exports = __webpack_public_path__ + "static/media/032.95d8efa2.png";